/**
 * Branch INITIATE_CHECKOUT Event Tracking
 * Tracks when user clicks checkout button (GoKwik or Standard Shopify)
 */

(function() {
  'use strict';

  // Prevent duplicate tracking
  let isTracking = false;
  let lastTrackTime = 0;
  const DEBOUNCE_TIME = 2000; // 2 seconds cooldown

  /**
   * Track Branch Initiate Checkout Event (with debouncing)
   */
  function trackCheckoutInitiation() {
    // Debounce: Don't track if already tracking or tracked recently
    const now = Date.now();
    if (isTracking || (now - lastTrackTime) < DEBOUNCE_TIME) {
      return;
    }

    if (typeof branch === 'undefined' || !window.BranchEvents || typeof window.BranchEvents.trackInitiateCheckout !== 'function') {
      return;
    }

    // Set tracking flag
    isTracking = true;

    // Fetch current cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Prepare cart items for Branch
        const items = cart.items.map(item => ({
          "$product_name": item.product_title,
          "$product_id": String(item.product_id),
          "$sku": item.sku || '',
          "$price": parseFloat(item.final_price / 100),
          "$quantity": item.quantity,
          "$product_variant": item.variant_title || ''
        }));

        // Prepare checkout data
        const checkoutData = {
          currency: 'INR',
          total: parseFloat(cart.total_price / 100),
          items: items
        };

        // Track the event
        window.BranchEvents.trackInitiateCheckout(checkoutData);

        // Update last track time
        lastTrackTime = Date.now();

      })
      .catch(error => {
        // Silent fail - log only critical errors
        if (console && console.error) {
          console.error('Branch tracking error:', error);
        }
      })
      .finally(() => {
        // Reset tracking flag after a delay
        setTimeout(() => {
          isTracking = false;
        }, 1000);
      });
  }

  /**
   * Setup checkout button listeners (only once)
   */
  let listenersAttached = false;

  function setupCheckoutListeners() {
    if (listenersAttached) return;

    // GoKwik and standard checkout buttons
    const buttons = document.querySelectorAll('.gokwik-checkout button, button[onclick*="onCheckoutClick"], button[name="checkout"], .cart__checkout-button');

    buttons.forEach(button => {
      if (!button.dataset.branchTracked) {
        button.addEventListener('click', trackCheckoutInitiation);
        button.dataset.branchTracked = 'true';
      }
    });

    listenersAttached = true;
  }

  // Initial setup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCheckoutListeners);
  } else {
    setupCheckoutListeners();
  }

  // Re-attach when cart drawer opens
  let cartDrawerObserved = false;
  function observeCartDrawer() {
    if (cartDrawerObserved) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawerObserved = true;
      const observer = new MutationObserver(function() {
        const newButtons = document.querySelectorAll('button:not([data-branch-tracked])');
        if (newButtons.length > 0) {
          listenersAttached = false;
          setupCheckoutListeners();
        }
      });
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  setTimeout(observeCartDrawer, 1000);

})();
